import { useContext, useEffect, useRef, useState } from "react";
import { APP_KEY_IDS } from "../../../constants/constants";
import Library from "../../gallery/library/Library";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import { ReactComponent as BackIcon } from "../../../icons/extra_icons/left.svg"
import { ReactComponent as MenuIcon } from "../../../icons/extra_icons/menu.svg"
import Styles from "./MobileGallery.module.scss";
import { useSwipeable } from "react-swipeable";
import { RootStateOrAny, useSelector } from "react-redux";
import classnames from "classnames"
import { getDateTimeFromTimestamp } from "../../../global/functions/functrions";
import { ToastContext } from "../../../contexts/toast/ToastContextProvider";

const MobileGallery = () => {

  const { showToast } = useContext(ToastContext)

  const [activeImage, setActiveImage] = useState<any>({
    id: "",
    index: undefined
  })

  const [showButton, setShowButton] = useState(true)

  const libraryImages = useSelector((state: RootStateOrAny) => state.handleLibraryImages)

  const containerRef = useRef<HTMLDivElement>(null);
  const [currentChildIndex, setCurrentChildIndex] = useState(0);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const childElements = Array.from(container.children);
          const currentIndex = childElements.findIndex(
            (child) => child === entry.target
          );

          if (currentIndex !== -1) {
            if (entry.intersectionRatio >= 0.5) {
              setCurrentChildIndex(currentIndex);
            }
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% or more of the element is visible
    );

    const childElements = Array.from(container.children);
    childElements.forEach((child) => observer.observe(child));

    return () => {
      childElements.forEach((child) => observer.unobserve(child));
      observer.disconnect();
    };
  }, []);

  const handleBackClick = (e?: any) => {
    setActiveImage(
      {
        id: "",
        index: -1
      }
    )
  }


  const setAsBackground = (type: string) => {
    document.documentElement.style.setProperty((`--mobile-${type}-image`), "url(" + libraryImages[activeImage.id] + ") no-repeat")
    showToast({
      [`settings_${Date.now()}`]: {
        appId: APP_KEY_IDS.SETTINGS,
        appName: "Settings",
        bannerImage: "",
        mobileAppId: APP_KEY_IDS.MOBILE_SETTINGS,
        subText: `${type} wallpaper has been changes`,
        time: getDateTimeFromTimestamp(Date.now()),
        title: "Hiring Offer",
        visitLink: ""
      }
    })
  }

  const handleImageClick = (id: string, index: number) => {
    setActiveImage({ id: id, index: index })

    if (containerRef.current) {
      containerRef.current.scrollLeft = 2000
    }
  }

  return (
    <BaseMobileAppContainer
      appId={APP_KEY_IDS.MOBILE_GALLERY}
      title={"Pictures"}
      MainScreen={
        <div className={Styles.image_container} >
          {
            showButton &&
            (
              <div className={Styles.top_bar}>
                <div className={Styles.icon}>
                  <BackIcon onClick={handleBackClick} />
                </div>
                <div className={Styles.menu_button}>
                  <MenuIcon />
                  <div className={Styles.options}>
                    <div className={Styles.button} onClick={() => { setAsBackground("background") }}>
                      Set as Homescreen
                    </div>
                    <div className={Styles.dvr}></div>
                    <div className={Styles.button} onClick={() => { setAsBackground("lockscreen") }}>
                      Set as Lockscreen
                    </div>
                  </div>
                </div>
              </div>

            )
          }

          <div className={Styles.full_images} ref={containerRef} >
            {
              Object.keys(libraryImages).map((key: string, index: number) => {
                return <section id={key} key={key} className={Styles.image}><img src={libraryImages[key]} onClick={() => { setShowButton(!showButton) }} /></section>
              })
            }
          </div>

          {/* <div style={{display:"none"}}>{scrollAmount}</div> */}

          {
            showButton && (
              <div className={Styles.image_belt}>
                <div className={Styles.images}>
                  {
                    Object.keys(libraryImages).map((key: string, index: number) => {
                      return (
                        <a href={`#${key}`}
                          onClick={() => { handleImageClick(key, index) }}
                          className={classnames(Styles.img, activeImage.index === index && Styles.active)}
                          style={{
                            background: `url(${libraryImages[key]}) no-repeat`,
                            backgroundSize: "cover", backgroundPosition: "center"
                          }}
                          key={key}
                        />
                      )
                    })
                  }
                </div>
              </div>
            )
          }
        </div>
      }
      isMainScreenActive={activeImage.index > -1}
      MainMenuOptions={
        <div className={Styles.container}>
          <div className={Styles.header}>
            13-Jun-2023
          </div>
          <div className={Styles.images_1}>
            {
              Object.keys(libraryImages).slice(0, 11).map((key: string, index: number) => {
                return (
                  <img className={Styles.image} src={libraryImages[key]} onClick={() => { handleImageClick(key, index) }} key={key} />
                )
              })
            }
          </div>

          <div className={Styles.header}>
            11-Jun-2023
          </div>
          <div className={Styles.images_2}>
            {
              Object.keys(libraryImages).slice(11, libraryImages.length).map((key: string, index: number) => {
                return (
                  <img className={Styles.image} src={libraryImages[key]} onClick={() => { setActiveImage({ id: key, index: index }) }} key={key} />
                )
              })
            }
          </div>
        </div>
      }
      handleBackClick={handleBackClick}
    />
  )
}

export default MobileGallery
